import App from "./App";
import AllAbout from "./About/AllAbout";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,RouterProvider,Route,Link,
} from "react-router-dom";
import AllDownload from "./Download/AllDownload";
import AllContact from "./Contact/AllContact";
import AllPrivacy from "./products/AllProducts";
import AllSingleProduct from "./SingleProduct/AllSingleProduct";
import { AllData } from "./Data/AllData";
import ScrollToTop from "react-scroll-to-top";



const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
  },
  {
    path: "about",
    element: <AllAbout/>,
  },
  {
    path: "download",
    element: <AllDownload/>,
  },
  {
    path: "contact",
    element: <AllContact/>,
  },
  {
    path: "products",
    element: <AllPrivacy/>,
  },
  {
    path: "singleProduct/:id",
    element: <AllSingleProduct/>,
  },
]);

createRoot(document.getElementById("root")).render(
  <AllData>
    <ScrollToTop 
    smooth
    viewBox="0 0 640 640"
    svgPath="M320 112C434.9 112 528 205.1 528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112zM320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM331.3 188.7C325.1 182.5 314.9 182.5 308.7 188.7L204.7 292.7C200.1 297.3 198.8 304.2 201.2 310.1C203.6 316 209.5 320 216 320L288 320L288 424C288 437.3 298.7 448 312 448L328 448C341.3 448 352 437.3 352 424L352 320L424 320C430.5 320 436.3 316.1 438.8 310.1C441.3 304.1 439.9 297.2 435.3 292.7L331.3 188.7z"
    color="#fff"
    // width="50px"
    style={{background:"#183153",width:"50px",height:"50px",borderRadius:"50%"}}
    
    />
    <RouterProvider router={router} />
    


  </AllData>
);
